import { useEffect, useRef, useState } from "react";

function LogPanel({ logPanelOpen, logs, idleMs = 3000 }) {
  const logsRef = useRef(null);
  const idleTimerRef = useRef(null);
  const [autoScroll, setAutoScroll] = useState(true);

  const isNearBottom = (el, threshold = 20) =>
    el.scrollHeight - el.scrollTop - el.clientHeight < threshold;

  const scheduleAutoResume = () => {
    // If user scrolled, pause now and schedule an auto-resume.
    clearTimeout(idleTimerRef.current);
    idleTimerRef.current = setTimeout(() => {
      const el = logsRef.current;
      if (!el) return;
      // Auto-resume: jump to bottom and re-enable follow
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
      setAutoScroll(true);
    }, idleMs);
  };

  const handleScroll = () => {
    const el = logsRef.current;
    if (!el) return;
    const atBottom = isNearBottom(el);
    setAutoScroll(atBottom);
    if (!atBottom) scheduleAutoResume();
    else clearTimeout(idleTimerRef.current);
  };

  // Follow new logs only if user has not scrolled away
  useEffect(() => {
    const el = logsRef.current;
    if (!el) return;
    if (autoScroll) {
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
    }
  }, [logs, autoScroll]);

  // Clear timers on unmount
  useEffect(() => {
    return () => clearTimeout(idleTimerRef.current);
  }, []);

  return (
    <>
      {logPanelOpen && (
        <div className="ui-card logs" style={{ left: 8, bottom: 8 }}>
          <div className="logs-body">
            <div className="logs-title">Logs</div>
            <hr/>
            <ul
              className="logs-list"
              ref={logsRef}
              onScroll={handleScroll}
              style={{
                overflowY: "auto",
                paddingRight: "8px",
                scrollBehavior: "smooth",
              }}
            >
              {logs.map((log, i) => (
                <li key={i}>{log}</li>
              ))}
            </ul>

            {!autoScroll && (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#aaa",
                  paddingTop: "4px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => {
                  const el = logsRef.current;
                  if (el) {
                    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
                    clearTimeout(idleTimerRef.current);
                    setAutoScroll(true);
                  }
                }}
                title={`Auto-resumes in ${Math.round(idleMs / 1000)}s`}
              >
                Scroll to bottom ⬇️
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default LogPanel;
